import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

const base =
  "group inline-flex items-center justify-center gap-2 rounded-full font-semibold transition-all duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:opacity-60 disabled:pointer-events-none";

const variants = {
  primary: "bg-foreground text-background hover:-translate-y-0.5 hover:shadow-xl",
  gradient: "brand-gradient-bg text-white hover:-translate-y-0.5 hover:shadow-xl hover:shadow-brand-teal/20",
  outline: "border border-border bg-transparent text-foreground hover:border-foreground/40 hover:bg-muted",
  ghost: "text-muted-foreground hover:text-foreground",
};

const sizes = {
  sm: "px-4 py-2 text-sm",
  md: "px-5 py-2.5 text-sm sm:text-base",
  lg: "px-7 py-3.5 text-base",
};

export default function CTAButton({
  as = "button",
  to,
  href,
  variant = "primary",
  size = "md",
  className = "",
  children,
  ...props
}) {
  const cls = cn(base, variants[variant], sizes[size], className);
  if (to) {
    return (
      <Link to={to} className={cls} {...props}>
        {children}
      </Link>
    );
  }
  if (href) {
    return (
      <a href={href} className={cls} {...props}>
        {children}
      </a>
    );
  }
  const Tag = as;
  return (
    <Tag className={cls} {...props}>
      {children}
    </Tag>
  );
}
